export default {
  sap: {
    metadata: {
      title: 'SAP Intelligence - SIS Innov & Tech',
      desc: 'SAP solutions to boost your business! From consulting and implementation to updates and AMS support. Learn more.',
    },
    hero: {
      title: 'SAP Intelligence',
      desc: 'Discover Our<br /> Services!',
    },
    apresentation: {
      p1: 'Having <span class="font-black">a trusted partner to support you at every stage of the process</span> is essential to ensuring your company has a market-leading ERP system that drives results.',
      p2: 'At our SAP Intelligence Unit, our specialists offer a complete and customizable approach to meet your company’s SAP system needs. With us, you get:',
      list: ['SAP Consulting;', 'Implementation;', 'Updates;', 'Support whenever needed.'],
    },
    carouselConsulting: {
      title: 'A Consulting Service Designed for You',
      list: [
        {
          title: 'Enterprise Resource Planning',
          text: 'SAP S/4HANA Cloud is a system with built-in AI, enabling real-time business operations from anywhere.',
          icon: '/images/sap/icons-carousel/1.svg',
        },
        {
          title: 'Financial Resource Management (GRC)',
          text: 'Centralize all financial operations in one place, from planning to Governance, Risk, and Compliance (GRC).',
          icon: '/images/sap/icons-carousel/2.svg',
        },
        {
          title: 'Human Capital Management',
          text: 'SAP solutions for talent management, employee experience, and HR-related functions.',
          icon: '/images/sap/icons-carousel/3.svg',
        },
        {
          title: 'Supply Chain Management',
          text: 'Implement SAP with us and manage your supply, production, and logistics chains.',
          icon: '/images/sap/icons-carousel/4.svg',
        },
        {
          title: 'Sales & Customer Experience',
          text: 'Connect e-commerce, sales, and service data to personalize customer interactions.',
          icon: '/images/sap/icons-carousel/5.svg',
        },
        {
          title: 'Business Network',
          text: 'Integrate people, processes, and technologies through the SAP ERP system.',
          icon: '/images/sap/icons-carousel/6.svg',
        },
      ],
    },
    whatIs: {
      title: 'What Does SAP Intelligence Include?',
      tooltip:
        '<span class="font-black">It’s important to note that by 2027</span>, all companies using SAP ECC <span class="font-black">must migrate to SAP S/4HANA.</span> If you are already using the tool and need a secure transition, we provide all the necessary support.',
      list: [
        {
          title:
            '<span class="font-black">SAP Consulting & Implementation</span><br><span style="font-weight: 100;">(ECC and S/4HANA)</span>',
          items: [
            '• Deployment and migration of current and future SAP applications;',
            '• Comprehensive SAP environment assessment, including customizations (Zs);',
            '• Improvements to existing applications;',
            '• Specialized team for full support.',
          ],
        },
        {
          title: '<span class="font-black">AMS Support</span>',
          items: [
            '• Support for business applications;',
            '• Dedicated AMS team to handle requests based on priority, severity, and mitigate impacts with root cause analysis and workaround solutions;',
            '• Proactive management, based on KPIs and service level agreements (SLAs).',
          ],
        },
        {
          title: '<span class="font-black">SAP CONCUR</span>',
          items: [
            '• Automation and simplification of corporate travel and expense processes;',
            '• Easy travel report submission and assistance with trip organization, from booking to reimbursement.',
          ],
        },
        {
          title: '<span class="font-black">PRICEFX</span>',
          items: [
            '• Optimized pricing processes;',
            '• Real-time data and insights for strategic decision-making;',
            '• Flexible and scalable price management.',
          ],
        },
        {
          title: '<span class="font-black">OMNIPOS</span><br><span style="font-weight: 100;">(OMNICHANNEL)</span>',
          items: [
            '• Seamless integration of sales channels (e-commerce, POS, and others) with ERP and legacy systems (omnichannel);',
            '• Management of multiple sales channels independently.',
          ],
        },
        {
          title: '<span class="font-black">ANFE</span>',
          items: [
            '• Management and automation of incoming electronic fiscal documents (NFe, CTe, NFSe);',
            '• Direct document retrieval from SEFAZ;',
            '• Document capture, audit, and classification;',
            '• Processing of all service invoices (PDF and XML).',
          ],
        },
      ],
      link: 'talk to us',
    },
    band: {
      title: 'Take the Next Step Toward<br> Innovation and Digital Transformation!',
      button: 'Contact Our SAP Intelligence Unit',
    },
    booster: {
      title: 'Boost Your Business with SAP Implementation!',
      desc: 'In a partnership with CoachIT, <span class="font-black">we personalize the ideal strategy to meet your company’s specific needs.</span> Using our extensive experience in technology, our consultants support you from implementation to continuous improvements, ensuring that you get the best results.',
      link: 'I Want to Enjoy SAP Benefits!',
    },
  },
}
